import { styled } from '@mui/material/styles'
import { CardContent } from '@mui/material'
import Typography from '../Typography/Typography'

const PREFIX = 'CommonCardContent'

const classes = {
  description: `${PREFIX}-description`,
}

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  [`&.${classes.description}`]: {
    flex: '1 1 auto',
    cursor: 'pointer',
    display: 'block',
  },
}))

const showDescription = props => {
  return <Typography variant="body2">{props.description}</Typography>
}

const CommonCardContent = props => {
  return (
    <StyledCardContent className={classes.description}>
      {props.description ? showDescription(props) : props.content}
    </StyledCardContent>
  )
}

export default CommonCardContent
